import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { INDOOR_PARTNERS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getIndoorPartnersAction = createAsyncThunk(
    'pod/getIndoorPartnersAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ INDOOR_PARTNERS_PATH }${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getIndoorPartnersSlice = createSlice({
    name: 'getIndoorPartnersSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getIndoorPartnersAction.pending, () => STATE__API__STARTED);
        builder.addCase(getIndoorPartnersAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getIndoorPartnersAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getIndoorPartnersState = (state) => state.pod.getIndoorPartners;
export default getIndoorPartnersSlice.reducer;